import React from 'react';
import { Box, keyframes } from '@mui/material';

// Fade in/out animation
const fade = keyframes`
  0%, 80%, 100% { opacity: 0.2; transform: scale(0.75); }
  40%          { opacity: 1;   transform: scale(1);    }
`;

export default function BubbleLoader({
    color = 'currentColor',
}) {
    // We’ll render three circles, each delayed by 0.2s
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '50%',
                height: '100%',
            }}
        >
            {[0, 1, 2].map((i) => (
                <Box
                    key={i}
                    sx={{
                        width: '0.3em',        // 30% of parent’s font-size
                        height: '0.3em',
                        borderRadius: '50%',
                        bgcolor: color,
                        animation: `${fade} 1.8s infinite ease-in-out`,
                        animationDelay: `${i * 0.2}s`,
                    }}
                />
            ))}
        </Box>
    );
}

